import React, {useState} from 'react';
import {useSelector} from "react-redux";
import useAsyncErrorHandler from "./useAsyncErrorHandler";
import useLoading from "./useLoading";
import * as Async from "../features/async";

export default function useCreateFile(config = {returnInnerLoadingState: false}) {
    const credencial = useSelector(state => state.credencial);
    const setLoading = useLoading();
    const asyncErrorHandler = useAsyncErrorHandler();
    const [innerLoading, setInnerLoading] = useState(false);

    const createFile = (url, data, onSuccess, onError, shouldFinishLoading = true) => {
        if (typeof onError === 'boolean') {
            shouldFinishLoading = onError;
            onError = undefined;
        }

        config.returnInnerLoadingState ? setInnerLoading(true) : setLoading(true);

        const asyncConfig = {...config};
        delete asyncConfig.returnInnerLoadingState;

        return Async.createFile(url, credencial, data, asyncConfig)
            .then(response => {
                onSuccess && onSuccess(response);
                return response;
            })
            .catch(error => {
                onError ? onError(error, asyncErrorHandler) : asyncErrorHandler(error);
            })
            .finally(() => {
                config.returnInnerLoadingState ? setInnerLoading(false) : (shouldFinishLoading && setLoading(false));
            });
    };

    return !config.returnInnerLoadingState ? createFile : [createFile, innerLoading];
}
